<template>
  <!-- Create / Edit -->
  <v-dialog
    v-model="dialog"
    width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
  >
    <v-card class="mx-auto overflow-hidden" width="600">
      <v-toolbar dense elevation="0">
        <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text style="height: auto" class="pa-0">
        <v-form ref="form" v-model="valid" lazy-validation autocomplete="off">
          <!-- ========================================= -->
          <!--             Registration form             -->
          <!-- ========================================= -->
          <v-subheader class="overline pt-4">{{
            $t("registrationForm")
          }}</v-subheader>
          <div class="pa-4 px-6">
            <v-text-field
              :label="$t('fullName')"
              v-model="form.fullName"
              :rules="fullNameRules"
              required
              clearable
              outlined
              dense
              autofocus
            ></v-text-field>
            <v-text-field
              label="CPF"
              v-model="form.doc"
              :rules="requiredRules"
              required
              clearable
              outlined
              v-mask="'###.###.###-##'"
              :disabled="edit"
              dense
            ></v-text-field>
            <v-text-field
              label="E-mail"
              v-model="form.email"
              :rules="emailRules"
              clearable
              outlined
              :disabled="edit"
              dense
              autocapitalize="off"
            ></v-text-field>
            <v-row>
              <div class="col-12 col-md-6 py-0">
                <v-text-field
                  :label="$t('mobile1')"
                  v-model="form.phone1"
                  :rules="requiredRules"
                  required
                  clearable
                  outlined
                  v-mask="'(##) #####-####'"
                  :disabled="edit"
                  dense
                ></v-text-field>
              </div>
              <div class="col-12 col-md-6 py-0">
                <v-text-field
                  :label="$t('mobile2')"
                  v-model="form.phone2"
                  clearable
                  outlined
                  v-mask="'(##) #####-####'"
                  :disabled="edit"
                  dense
                ></v-text-field>
              </div>
            </v-row>
            <v-row>
              <div class="col-12 col-md-4 py-0">
                <v-text-field
                  label="Cep"
                  v-model="form.zipCode"
                  :loading="loadingZipCode"
                  :disabled="disabled || edit"
                  required
                  :readonly="edit"
                  outlined
                  v-mask="'##.###-###'"
                  append-icon="mdi-magnify"
                  @click:append="consultZipCode(form.zipCode)"
                  @blur="consultZipCode(form.zipCode)"
                  dense
                ></v-text-field>
              </div>
              <div class="col-12 col-md-8 py-0">
                <v-text-field
                  :label="$t('address')"
                  v-model="form.address"
                  :disabled="disabled || edit"
                  required
                  :clearable="!edit"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </v-row>
            <v-row>
              <h6 class="grey--text ml-3 mb-4">
                {{ $t("toSaveStateMsg") }}
              </h6>
              <div class="col-12 col-md-6 py-0">
                <v-select
                  v-model="form.state.select"
                  :items="form.state.items"
                  item-text="nome"
                  item-value="id"
                  :label="$t('state')"
                  :disabled="disabled || edit"
                  outlined
                  return-object
                  persistent-hint
                  :loading="loadingState"
                  @change="getCitys(form.state.select.id)"
                  required
                  dense
                ></v-select>
              </div>
              <div class="col-12 col-md-6 py-0">
                <v-select
                  v-model="form.city.select"
                  :items="form.city.items"
                  item-text="nome"
                  item-value="id"
                  :label="$t('city')"
                  :disabled="disabled || edit"
                  outlined
                  return-object
                  required
                  dense
                ></v-select>
              </div>
            </v-row>
          </div>
          <!-- ========================================= -->
          <!--                  Limits                   -->
          <!-- ========================================= -->
          <template v-if="permissions.limits == 1">
            <v-subheader class="overline pt-4">{{ $t("limits") }}</v-subheader>
            <div class="pa-4 px-6">
              <v-text-field
                v-model="form.limitDayBet"
                :label="$t('dailyBettingLimit')"
                :prefix="$t('labelCurrency')"
                outlined
                :rules="requiredRules"
                type="number"
                dense
              ></v-text-field>
              <v-text-field
                v-model="form.limitDayBetSingle"
                :label="$t('dailyLimitSingleBets')"
                :prefix="$t('labelCurrency')"
                outlined
                :rules="requiredRules"
                type="number"
                dense
              ></v-text-field>
              <v-text-field
                v-model="form.limitDayBetDouble"
                :label="$t('dailyLimitDoubleBets')"
                :prefix="$t('labelCurrency')"
                outlined
                :rules="requiredRules"
                type="number"
                dense
              ></v-text-field>
            </div>
          </template>
          <template v-if="permissions.credit_agent == 1">
            <v-subheader class="overline pt-4">{{
              retail == 1 ? $t("agentBalance") : $t("generalSalesLimit")
            }}</v-subheader>
            <div class="pa-4 px-6">
              <v-text-field
                v-model="form.limit_retention"
                :label="retail == 1 ? $t('agentBalance') : $t('salesLimit')"
                :prefix="$t('labelCurrency')"
                outlined
                dense
                :rules="retail == 1 ? [] : requiredRules"
                type="number"
                :disabled="showAgentBalanceIncrement && retail == 1"
              ></v-text-field>
            </div>
            <!-- Aumenta ou reseta o saldo (retail 1) -->
            <div
              class="pa-4 px-6"
              v-if="retail == 1 && showAgentBalanceIncrement"
            >
              <v-btn @click="showEditBalance = !showEditBalance" class="mb-3">
                {{ $t("editAgentBalance") }}
              </v-btn>
              <div v-if="showEditBalance">
                <v-text-field
                  v-model="form.limit_retention_increment"
                  :label="$t('incrementAgentBalance')"
                  :prefix="$t('labelCurrency')"
                  outlined
                  dense
                  type="number"
                ></v-text-field>
                <div v-if="retail == 1" class="d-flex justify-space-around">
                  <v-btn
                    class="mb-3"
                    :loading="loadingLimitRetentionAdd"
                    v-on:click.prevent="addLimitRetention"
                    >{{ $t("add") }}
                  </v-btn>
                  <v-btn
                    class="mb-3"
                    :loading="loadingLimitRetentionReset"
                    v-on:click.prevent="resetLimitRetention"
                    >{{ $t("reset") }}
                  </v-btn>
                </div>
              </div>
            </div>
          </template>
          <!-- ========================================= -->
          <!--              Configurations               -->
          <!-- ========================================= -->
          <v-subheader class="overline pt-4">{{ $t("settings") }}</v-subheader>
          <div class="pa-4 px-6">
            <v-select
              v-model="form.occupationArea.select"
              :items="form.occupationArea.items"
              item-text="name"
              item-value="id"
              :label="$t('areaOfExpertise')"
              outlined
              return-object
              :rules="selectRules"
              required
              dense
            ></v-select>
          </div>
          <!-- ========================================= -->
          <!--                CredentialS                -->
          <!-- ========================================= -->
          <v-subheader class="overline pt-4">{{
            $t("accessCredential")
          }}</v-subheader>
          <div class="pa-4 px-6">
            <v-text-field
              label="Login"
              v-model="form.login"
              :rules="usernameRules"
              required
              clearable
              outlined
              dense
            ></v-text-field>
            <template>
              <v-text-field
                :class="[
                  !form.password || show ? 'show-password' : 'hide-password',
                ]"
                :label="$t('password')"
                v-model="form.password"
                :rules="passwordRules"
                required
                clearable
                outlined
                dense
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show = !show"
                type="text"
                :counter="8"
                maxlength="8"
                autocapitalize="off"
              ></v-text-field>
              <v-text-field
                :class="[
                  !form.confirmPassword || show1
                    ? 'show-password'
                    : 'hide-password',
                ]"
                :label="$t('confirmPassword')"
                v-model="form.confirmPassword"
                :rules="confirmPasswordRules"
                required
                clearable
                outlined
                dense
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show1 = !show1"
                type="text"
                :counter="8"
                maxlength="8"
                autocapitalize="off"
              ></v-text-field>
            </template>
          </div>
          <!-- ========================================= -->
          <!--                 Actions                   -->
          <!-- ========================================= -->
          <v-divider></v-divider>

          <v-alert
            class="ma-4"
            type="warning"
            v-for="item in handleError.items"
            :key="item"
          >
            {{ item }}
          </v-alert>

          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="info"
              :loading="loading"
              v-on:click.prevent="updateAgent"
              type="submit"
              :disabled="!valid"
              >{{ $t("toSave") }}</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { validate } from "@/util/validate";
export default {
  name: "local-manager-user-update",
  data: () => ({
    showEditBalance: false,
    loadingLimitRetentionAdd: false,
    loadingLimitRetentionReset: false,
    retail: null,
    showAgentBalanceIncrement: false,
    edit: false,
    valid: false,
    loading: false,
    disabled: false,
    loadingZipCode: false,
    loadingState: false,
    show: false,
    show1: false,
    handleError: {
      items: [],
    },
    form: {
      // Sector: Registration form
      fullName: "",
      doc: "",
      phone1: "",
      phone2: "",
      email: "",
      zipCode: "",
      address: "",
      state: {
        select: [],
        items: [],
      },
      city: {
        select: [],
        items: [],
      },
      //  Sector: Limits
      limitDayBet: undefined,
      limitDayBetSingle: undefined,
      limitDayBetDouble: undefined,
      limit_retention: undefined,
      //  Sector: Configurations
      occupationArea: {
        select: [],
        items: [],
      },
      // Sector: CredentialS
      login: "",
      password: "",
      confirmPassword: "",
    },
    // Transforma type password em type text
    fieldTypes: {
      password: "text",
    },
    // Validate Forms:
    fullNameRules: [validate.required, validate.max],
    docRules: [validate.required, validate.docMaxEdit],
    emailRules: [validate.validEmail],
    phone1Rules: [validate.required, validate.phoneCounter],
    phone2Rules: [validate.phoneCounter],
    selectRules: [validate.selectRequired],
    requiredRules: [validate.required, validate.max],
    usernameRules: [
      validate.required,
      validate.usernameMax,
      validate.username,
      validate.max,
    ],
    passwordRules: [
      validate.required,
      validate.passRule,
      validate.passCaracter,
      validate.max,
    ],
    // Permissions:
    permissions: {
      limits: 0,
    },
    // Edit
    id_agent: "",
  }),
  mounted() {
    this.retail = localStorage.getItem("operator-retail");
    const isEditAgentRoute = this.$route.name == "LocalManagerUserEdit";

    if (isEditAgentRoute) {
      this.showAgentBalanceIncrement = true;
    }
  },
  async created() {
    // Retrieve States
    // Retrieve Occupation Area
    // Retrieve Permissions
    let statesResponse = this.$axios.get("player/register/fetchStates");
    let occupationAreaResponse = this.$axios.get(
      "localManager/profile/areasLocal"
    );
    let permissionsResponse = this.$axios.get(
      "localManager/profile/permissions"
    );

    // Request's Simultaneously
    let occupationArea = await occupationAreaResponse;
    let states = await statesResponse;
    let permissions = await permissionsResponse;

    // Set Responses:
    this.form.state.items = states.data.dados;
    this.form.occupationArea.items = occupationArea.data.dados;
    this.permissions.limits = permissions.data.dados.limit_agent;
    this.permissions.credit_agent = permissions.data.dados.credit_agent;

    // =================================================== //
    // IF - Edit
    // =================================================== //

    if (!this.$route.params.id) {
      return;
    }

    this.edit = true;

    let id_user = this.$route.params.id;
    let data = await this.$request.post("/localManager/agents/getAgent", {
      id_user,
    });

    const {
      id,
      name_agent,
      document,
      telephone,
      phone,
      zip_code,
      address,
      email,
      id_area,
      occupation_area,
      total_daily,
      total_daily_simple,
      total_daily_double,
      login_agent,
      limit_retention,
    } = data.dados;
    // Registration form
    this.form.fullName = name_agent;
    this.form.doc = document;
    this.form.email = email;
    this.form.phone1 = phone;
    this.form.phone2 = telephone;
    this.form.zipCode = zip_code;
    this.form.address = address;
    this.consultZipCode(zip_code);
    //  Sector: Configurations
    this.form.occupationArea.select = {
      id: id_area,
      name: occupation_area,
    };
    // Limits
    this.form.limitDayBet = total_daily;
    this.form.limitDayBetSingle = total_daily_simple;
    this.form.limitDayBetDouble = total_daily_double;
    this.form.limit_retention = limit_retention;
    // Login
    this.form.login = login_agent;
    // Edit
    this.id_agent = id;
  },

  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
    // Confirm Password Rules:
    confirmPasswordRules() {
      const rules = [];
      if (this.form.confirmPassword) {
        if (this.form.password === this.form.confirmPassword) {
          return [];
        } else {
          const rule = (v) =>
            (!!v && v) !== this.form.password && this.$t("repeatThePassword");
          rules.push(rule);
        }
      }
      return rules;
    },
  },
  watch: {
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },
  methods: {
    async addLimitRetention() {
      this.loadingLimitRetentionAdd = true;

      const value = this.form.limit_retention_increment;

      const body = { id_user: this.$route.params.id, value };

      try {
        const response = await this.$request.post(
          "/localManager/retail/agents/addAgentCredit",
          body
        );
        this.form.limit_retention = response.dados.credito_atual;
        this.$store.commit("setFeedbackSnack", {
          msg: response.messages,
          color: "success",
        });
      } catch (e) {
        console.error(e);
      }

      this.loadingLimitRetentionAdd = false;
    },
    async resetLimitRetention() {
      this.loadingLimitRetentionReset = true;

      try {
        const response = await this.$request.post(
          "/localManager/retail/agents/resetAgentCredit",
          { id_user: this.$route.params.id }
        );
        this.form.limit_retention = 0;
        this.$store.commit("setFeedbackSnack", {
          msg: response.messages,
          color: "success",
        });
      } catch (e) {
        console.error(e);
      }

      this.loadingLimitRetentionReset = false;
    },
    //
    //
    // Consult CEP (ZipCode)
    async consultZipCode(zipCode) {
      if (!zipCode) return;
      const body = {
        cep: zipCode.replace(/[^0-9]+/g, ""),
      };

      // handle fields
      this.disabled = true;
      this.loadingZipCode = true;

      try {
        // 1. Resques CEP/ZipCode
        const response = await this.$request.post(
          "player/register/fetchCep",
          body
        );

        // 2. Handle Address:
        this.form.address = response.dados.logradouro;

        // 3. Handle Select-State:
        const uf = response.dados.uf;
        const state = this.form.state.items.filter((item) => item.uf == uf);
        this.form.state.select = state[0];

        this.getCitys(state[0].id, response.dados.cidade);
      } catch (error) {
        console.log(error);
      } finally {
        // handle fields end.
        this.loadingZipCode = false;
        this.disabled = false;
      }
    },

    //
    //
    // getCitys
    async getCitys(stateId, nameCity) {
      this.loadingState = true;
      this.disabled = true;
      try {
        const citys = await this.$request.post("player/register/fetchCities", {
          id_state: stateId,
        });
        this.form.city.items = citys.dados;
        if (!nameCity) {
          return;
        }
        const city = this.form.city.items.filter(
          (item) => item.nome == nameCity.toUpperCase()
        );
        this.form.city.select = city[0];
      } catch (error) {
        console.log(error);
      } finally {
        this.disabled = false;
        this.loadingState = false;
      }
    },

    //
    //
    // updateAgent: Create or Edit Agent.
    async updateAgent() {
      if (!this.$refs.form.validate() && !this.edit) {
        return;
      }

      if (this.form.phone1 && this.form.doc) {
        if (this.form.phone1.length != 15) {
          this.$store.commit("setFeedbackSnack", {
            msg: this.$t("phoneMustCointais11Digits"),
            color: "red",
          });
          return;
        }
        if (this.form.doc.length != 14) {
          this.$store.commit("setFeedbackSnack", {
            msg: this.$t("phoneMustCointais11Digits"),
            color: "red",
          });
          return;
        }
      }
      // Global progress
      this.$store.commit("setFeedbackProgress", true);
      this.loading = true;

      // Body Request Verify Login
      const verifyLogin = {
        domain: this.$localStorage.getItem("user_data").db_name,
        login: this.form.login,
      };

      // Body Request Create Agent
      const formUpdateAgent = {
        login: this.form.login,
        nome: this.form.fullName,
        id_area: this.form.occupationArea.select.id,
        password: this.form.password,
        email: this.form.email,
        cpf: this.form.doc.replace(/[^0-9]+/g, ""),
        endereco: this.form.address,
        municipio: this.form.city.select.id,
        estado: this.form.state.select.id,
        telefone: this.form.phone2.replace(/[^0-9]+/g, ""),
        celular: this.form.phone1.replace(/[^0-9]+/g, ""),
        cep: this.form.zipCode.replace(/[^0-9]+/g, ""),
        limite_simples: this.form.limitDayBetSingle,
        limite_duplas: this.form.limitDayBetDouble,
        limite_diario: this.form.limitDayBet,
        credito_atual: this.form.limit_retention,
      };

      // Submit Form
      try {
        if (this.edit) {
          Object.assign(formUpdateAgent, { id_agent: this.id_agent });
          delete formUpdateAgent["cpf"];
          delete formUpdateAgent["endereco"];
          delete formUpdateAgent["municipio"];
          delete formUpdateAgent["estado"];
          delete formUpdateAgent["telefone"];
          delete formUpdateAgent["celular"];
          delete formUpdateAgent["cep"];
        } else {
          // Add Agent - Verify existing login
          const verify = await this.$request.post(
            "main/fetchLogin",
            verifyLogin
          );
          if (verify.length == 0) {
            return;
          }
        }

        const updateEndpoint = this.edit
          ? "localManager/agents/editAgent"
          : "localManager/agents/addAgent";

        const result = await this.$request.post(
          updateEndpoint,
          formUpdateAgent
        );
        if (result.length == 0) {
          return;
        }

        this.$store.commit("setFeedbackSnack", {
          msg: result.messages,
          color: "success",
        });

        if (!this.edit) {
          this.$refs.form.reset();
        }

        this.$store.commit("showDialog", false);
        this.$store.commit("setRefresh", true);
      } catch (error) {
        // Multiple error handler:
        if (error.response.status == 406) {
          const items = [];
          var obj = error.response.data.messages;
          for (var [key, value] of Object.entries(obj)) {
            const item = `${key}: ${value}`;
            items.push(item);
          }
          this.handleError.items = items;
        }
      } finally {
        this.loading = false;
      }
    },
    // Close Dialog
    closeDialog() {
      this.$store.commit("showDialog", false);
    },
    // Tratando password
    // handleType() {
    //   this.fieldTypes.password = "password";
    // },
  },
};
</script>
